export default __webpack_public_path__ + "static/Cali-disabled-47ed20036ba26eaf44cac9cf1dfb39fe.svg";